module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content-body "
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Leiloeiro")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('form', [_c('div', {
    staticClass: "form-group wrapper-md"
  }, [_c('div', {
    staticClass: "row m-b-md"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-md"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Uf")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-xs"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cep")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Fax")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn w-xs m-r-md btn-default"
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn w-xs btn-info"
  }, [_vm._v("Cadastrar")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89bce5f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloeiro/components/NovoLeiloeiro.vue
// module id = 1792
// module chunks = 17